import isApiError from "@insite/client-framework/Common/isApiError";
import { patch } from "@insite/client-framework/Services/ApiService";
import { BaseModel } from "@insite/client-framework/Types/ApiModels";

export interface PickupWindowApiResultModel {
    uri?: string;
    order?: {
        id?: string;
        warehouseId?: string;
        pickUpTimeSlot?: string;
        pickUpDate?: string;
    };
    properties?: {
        [key: string]: any;
    };
}

export interface UpdatePickupScheduleApiResult {}

const url = "/api/v1/osn";

export async function updatePickupScheduleService(
    orderId: string,
    pickUpTimeSlot: string,
    warehouseId: string,
    pickUpDate: string,
    lineIds: string,
) {
    interface ApiParameterModel extends BaseModel {
        orderId: string;
        pickUpTimeSlot: string;
        warehouseId: string;
        pickUpDate: string;
        lineIds: string;
    }

    try {
        const result = await patch<ApiParameterModel & UpdatePickupScheduleApiResult>(`${url}/updatePickUpWindow`, {
            orderId,
            pickUpTimeSlot,
            warehouseId,
            pickUpDate,
            lineIds,
        });
        return {
            successful: true,
            result,
        };
    } catch (error) {
        if (isApiError(error)) {
            return {
                successful: false,
                errorMessage: error.errorJson.message || "Something went wrong!",
            };
        }
        if ("status" in error && error.status.toString().startsWith("4")) {
            return {
                successful: false,
                errorMessage: error.errorMessage || "Something went wrong!",
            };
        }
        throw error;
    }
}
